import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './globals.css';
import App from './App.tsx';
import { setupFetchInterceptor } from './utils/setupFetchInterceptor';

// Configurar interceptor global do fetch para renovação automática de token
setupFetchInterceptor();

// Suprimir erros de extensões do navegador
window.addEventListener('error', (e) => {
  if (
    e.message?.includes('Extension context invalidated') ||
    e.message?.includes('Receiving end does not exist') ||
    e.message?.includes('message port closed')
  ) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message?.includes('Extension context invalidated') ||
    e.reason?.message?.includes('Receiving end does not exist') ||
    e.reason?.message?.includes('message port closed')
  ) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
